import { Image } from '@bw/elements';
import Link from 'next/link';
import { CalendlyButton } from '../../CalendlyButton/CalendlyButton';
import styles from './header-desktop-menu.module.scss';

interface DesktopMenuProps {
	menu: any[];
	activeMenuItem: any | null;
	onMenuItemClick: () => void;
	menuHeight: number | null;
	onClose: () => void;
	actionLinks: any[] | undefined;
}

export const DesktopMenu = ({
	activeMenuItem,
	onMenuItemClick,
	menuHeight,
	onClose,
	actionLinks,
}: DesktopMenuProps) =>
	activeMenuItem && (
		<div
			className={styles.megaMenuContainer}
			style={{ maxHeight: `${menuHeight}px` }}
		>
			<div
				className={`${styles.menuDesktopBanner} ${(activeMenuItem as any).fields.containsDualList ? styles.containsDualList : ''}`}
			>
				<div className={styles.menuDesktopContentWrapper}>
					<h5 className={styles.menuHeading}>
						{(activeMenuItem as any).fields.title}
					</h5>
				</div>
				<div>
					<div className={styles.menuDesktopContentWrapper}>
						<div>
							<h5 className={styles.subMenuHeadingSection}>Explore</h5>
							<ul data-lenis-prevent>
								{((activeMenuItem as any).fields.subMenu ?? []).map(
									(subMenuItem: any, index: number) => (
										<li
											key={index}
											className={styles.menuDesktopContent}
											data-menu-index={index}
										>
											{subMenuItem.sys?.contentType?.sys?.id === 'menuItem' ? (
												<h3>{subMenuItem.fields.title}</h3>
											) : (
												<h3>
													{!subMenuItem.fields
														.containsBookACallFunctionality ? (
														<Link
															href={subMenuItem.fields.url}
															onClick={onMenuItemClick}
														>
															{subMenuItem.fields.text}
														</Link>
													) : (
														<CalendlyButton
															className={styles['menu-list-desktop']}
															title={subMenuItem.fields.text}
															isMenuButton
														/>
													)}
												</h3>
											)}
										</li>
									)
								)}
							</ul>
						</div>
						<div className={styles.menuBottomContent}>
							{(activeMenuItem as any).fields.hideMenuActionSection ? (
								<></>
							) : (
								(actionLinks ?? []).map((item: any, index: number) => (
									<h5 key={index}>
										<Link href={item.fields.url} onClick={onMenuItemClick}>
											{item.fields.text}
										</Link>
									</h5>
								))
							)}
						</div>
					</div>
				</div>
				<div
					className={styles.menuDesktopImageContent}
					data-aos="zoom-in"
					data-aos-delay="200"
				>
					{(activeMenuItem as any).fields.menuBannerImage?.fields.file?.url ? (
						<Image
							src={
								(activeMenuItem as any).fields.menuBannerImage?.fields.file?.url
							}
							alt={(activeMenuItem as any).fields.menuBannerImage?.fields.title}
							width={1000}
							height={1000}
						/>
					) : (
						<></>
					)}
				</div>
			</div>
			<div className={styles.megaMenuFooter}>
				<button
					onClick={onClose}
					onKeyDown={(e) => {
						// Close the menu on pressing the ESC key
						if (e.key === 'Escape') {
							onClose();
						}
					}}
					title="Close Button"
				>
					Close &nbsp;
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M18 6L6 18M6 6L18 18"
							stroke="white"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</button>
			</div>
		</div>
	);
